const D200_VENDOR_ID = 0x2207;
const D200_PRODUCT_ID = 0x0019;

function ensureHidSupport(): void {
  if (!('hid' in navigator)) {
    throw new Error(
      'WebHID is not supported in this browser. Use Chrome or another Chromium-based browser.',
    );
  }
}

export async function requestDevice(): Promise<HIDDevice | undefined> {
  ensureHidSupport();
  const devices = await navigator.hid.requestDevice({
    filters: [{ vendorId: D200_VENDOR_ID, productId: D200_PRODUCT_ID }],
  });
  return devices[0];
}

export async function getDevices(): Promise<HIDDevice[]> {
  ensureHidSupport();
  const all = await navigator.hid.getDevices();
  return all.filter(
    (d) => d.vendorId === D200_VENDOR_ID && d.productId === D200_PRODUCT_ID,
  );
}

export async function connectDevice(device: HIDDevice): Promise<HIDDevice> {
  if (!device.opened) {
    await device.open();
  }
  return device;
}

export async function disconnectDevice(device: HIDDevice): Promise<void> {
  if (device.opened) {
    await device.close();
  }
}
